import type { Config, DriveStep, State, Driver } from 'driver.js';
import type { TourConfig } from 'tio-common/services/tour-manager';

const courseCashDashboard: TourConfig = {
  id: 'course-cash-dashboard',
  name: 'Course Cash Dashboard Tour',
  steps: [
    {
      element: '#course-cash-eligible',
      popover: {
        title: 'CourseCa$h™ Eligible',
        description:
          'CourseCa$h™ eliminates the need to pay for courses upfront and wait for reimbursement, making the process of using their education benefits seamless and stress-free. The technology is powered by Stripe, a leading global payments processing company',
        side: 'right',
        align: 'start',
      },
    },
  ],
  driverOptions: {
    smoothScroll: true,
    showButtons: ['close'],
    showProgress: false,
  },
};

const courseCashApplicationPage = (openEducationDrawer: () => void): TourConfig => {
  return {
    id: 'course-cash-application',
    name: 'Course Cash Application Page Tour',
    steps: [
      {
        element: '.add-education-drawer-button',
        popover: {
          title: 'CourseCa$h™ Eligible',
          description: 'This is where you add course details',
          side: 'left',
          align: 'end',
          onNextClick: (
            _element: Element,
            _step: DriveStep,
            options: { config: Config; state: State; driver: Driver }
          ) => {
            openEducationDrawer();
            setTimeout(() => {
              options.driver.moveNext();
            }, 500); // Wait for drawer
          },
        },
      },
      {
        element: '.tuition-input',
        popover: {
          title: 'CourseCa$h™ Eligible',
          description:
            'Enter the cost for Tuition and other charges. Note that CourseCa$h™ is valid to pay tuition only.',
          side: 'left',
          align: 'start',
        },
      },
      {
        element: '.course-cash-pencil',
        popover: {
          title: 'CourseCa$h™ Eligible',
          description:
            'Click here to see all cost breakdown. You can update the payment method (CourseCa$h™ for Tuition, or Reimbursement for the full total). Once you have made the edits and submitted the application, this cannot be changed.',
          side: 'left',
          align: 'start',
          onPrevClick: (
            _element: Element,
            _step: DriveStep,
            options: { config: Config; state: State; driver: Driver }
          ) => {
            openEducationDrawer();
            setTimeout(() => {
              options.driver.movePrevious();
            }, 500); // Wait for drawer
          },
        },
      },
    ] as DriveStep[],
    driverOptions: {
      smoothScroll: false,
      showButtons: ['next', 'previous', 'close'],
      showProgress: true,
    },
  };
};

export { courseCashDashboard, courseCashApplicationPage };
